/** @format */

import NewUpload from "./upload";

export default NewUpload;